import { jsx as o, Fragment as e } from "react/jsx-runtime";
import { Star as i } from "../Star/index.js";
function c({ rating: r, size: m }) {
  return /* @__PURE__ */ o(e, { children: [0, 1, 2, 3, 4].map((t) => {
    const n = r >= t + 0.25 && r < t + 0.75, s = t < Math.round(r);
    return /* @__PURE__ */ o(i, { size: m, isFull: s, isHalf: n });
  }) });
}
export {
  c as Ratings
};
